<template>
  <div class="collection">
    <div class="PageHeader">
      <el-breadcrumb>
        <el-breadcrumb-item>{{l("我的收藏")}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="PageContent">
      <el-table
        :data="TableList"
        :stripe="true"
        @selection-change="HandleSelectionChange"
        @sort-change="HandleSortChange"
      >
        <TableOperation
          :operationList="[
            {
              is_show: (row) => row.info.status == 1,
              label: l('前往'),
              command: 'goItem',
            },
            {
              is_show: (row) => true,
              label: l('取消收藏'),
              command: 'cancelCollect',
            },
          ]"
          @handleOperation="HandleOperation"
        />

        <el-table-column :label="l('类型')">
          <template slot-scope="scope">
            <div v-if="scope.row.module == 'quotation'">{{l("现货卖场")}}</div>
            <div v-else-if="scope.row.module == 'purchase'">
              <span v-if="scope.row.info.quality_type == 1">{{l("原料求购")}}</span>
              <span v-else-if="scope.row.info.quality_type == 2">{{l("零切交易")}}</span>
              <span v-else-if="scope.row.info.quality_type == 3">{{l("锻件定制")}}</span>
            </div>
          </template>
        </el-table-column>

        <!-- <el-table-column label="图片" width="120">
          <template slot-scope="scope">
            <div class="ImageInTable">
              <el-image
                v-if="scope.row.info.img_array[0]"
                :src="scope.row.info.img_array[0]"
                fit="contain"
                :preview-src-list="scope.row.info.img_array"
              ></el-image>
            </div>
          </template>
        </el-table-column> -->

        <el-table-column
          prop="info.title"
          :label="l('标题')"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column :label="l('状态')" width="150">
          <template slot-scope="scope">
            <div
              v-if="scope.row.info.status == -1 || scope.row.info.status == 0"
              style="color: #999"
            >
              {{l("已失效")}}
            </div>
            <div v-else-if="scope.row.info.is_expire" style="color: #999">
              {{l("已截止")}}
            </div>
            <div v-else-if="scope.row.info.status == 1" class="color-success">
              {{l("已上架")}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="created_time"
          :label="l('收藏日期')"
          sortable="custom"
          width="150"
        >
          <template slot-scope="scope">
            {{ scope.row.created_time.slice(0, 10) }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="HandleSizeChange"
        @current-change="HandleCurrentChange"
        :current-page="CurrentPage"
        :page-sizes="PageSizeList"
        :page-size="PageSize"
        layout="total, prev, pager, next, jumper"
        :total="TotalCount"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";

export default {
  name: "Collection",
  mixins: [tableMixin],
  data() {
    return {
      SearchData: {
        status: 1,
      },
      PageSize: 10,
    };
  },
  mounted() {},
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;
      this.axios
        .get("/api/user_collection/", {
          params: {
            ...this.SearchData,
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results.map((item) => {
            item.info.img_array = JSON.parse(item.info.img_array);
            return item;
          });
        });
    },
    cancelCollect(item) {
      this.$confirm(`${this.l("是否取消收藏")}【${item.info.title}】?`, "", {
        type: "warning",
      }).then(() => {
        //axios delete的body需要包装在data内
        this.axios
          .delete(`/api/user_collection/cancel/`, {
            data: {
              code: item.info.code,
            },
          })
          .then(() => {
            this.GetTableList();
          });
      });
    },
    goItem(item) {
      if (item.module == "quotation") {
        this.$openRouter({
          path: `/home/quotation/${item.info.code}`,
        });
      } else if (item.module == "purchase") {
        if (item.info.quality_type == 1) {
          this.$openRouter({
            path: `/home/purchase_material/${item.info.code}`,
          });
        } else if (item.info.quality_type == 3) {
          this.$openRouter({
            path: `/home/purchase_forging/${item.info.code}`,
          });
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>

